import React from 'react'

//-- components
import { useStateProps ,useImageProps ,useFormatProps } from '../ImpaasComponents.js';
import ImageLoader from '../ImageLoader.tsx';
import ImageSaver from '../ImageSaver.tsx';
import FormatSelect from '../FormatSelect.tsx';

//-- ui
import { Collapse, Alert } from "antd";

//-- css
import './ConvertApp.css';

//! *** Main Component ***
export default function ConvertApp(props) {

//-- ImPaaS component
    const { onStateChanges ,isQueuing ,adviseDownload ,adviseQueuing } = useStateProps(props);
    const { hasImage ,imageUrl ,imageInfoHeader ,onImageUpload } = useImageProps(props);
    const { formatName ,formatSelect } = useFormatProps(props);

//-- IMAGE
    function onImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
        onStateChanges(false);
    }

//-- PARAMETERS
    //...

//-- COMPONENT
    const { Panel } = Collapse;

    return (
        <div className="ConvertApp">
            <div class="upload-container">
            
            {!!imageUrl && (
                <>
                <div style={{textAlign: 'left' }}>
                    <Alert message={imageInfoHeader} type="info" showIcon />
                </div>
                <div class="canvas-container">
                    <div class="convert-canvas">
                        <img
                            alt="Convert"
                            src={imageUrl}
                            onLoad={onImageLoad}
                        />
                    </div>
                </div>
                </>
            )}
            <hr/>
            <div class="container-fluid d-flex justify-content-between align-items-center">
                <div class="container-fluid d-flex justify-content-center">
                {!isQueuing && (
                    <ImageLoader onUpload={onImageUpload}/>
                )}
                <ImageSaver enabled={hasImage} queueTime="5" onDownload={adviseDownload} onQueue={adviseQueuing}/>
                </div>
            </div>
            </div>
            
            <div class="method-group">
                <ul class="property-list">
                <Collapse defaultActiveKey={['1']}>
                    <Panel header={<h6>Format</h6>} key="1" className="property-panel">
                        <FormatSelect enabled={hasImage} name={formatName} onSelect={formatSelect} />
                    </Panel>
                </Collapse>
                </ul>      
            </div>
        </div>
    )
}